// @flow
import { handleResponseOld, makePost } from './helpers';

type PostConsignmentParams = {
    authToken: string,
    deployment: string,
    file: any,
    form: any,
    userData: any,
};

export default {
    postConsignment: ({ authToken, deployment, file, form, userData }: PostConsignmentParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ authToken, deployment, path: '<ITEM-API>spa/consignment/upload' });
            const address = `${userData.address}${userData.address2 ? `${' ' + userData.address2}` : ''}`;
            request
                .field('address', address)
                .field('city', userData.city)
                .field('country', userData.country)
                .field('description', form.description)
                .field('email', form.email)
                .field('multi2', form.multi2)
                .field('name', `${userData.firstName} ${userData.lastName}`)
                .field('other', form.other)
                .field('state', userData.state)
                .field('telephone', userData.mobileNumber)
                .attach('photo', file)
                .end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
